"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.CaseEvidenceTable2 = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var _case_lang_1 = require("../case-detail/_case.lang");
var classnames_1 = __importDefault(require("classnames"));
var ui_common_1 = require("@codametrix/ui-common");
var evidenceVerb = {
    partial: 'contains',
    complete: 'is',
    mapping: 'is'
};
var NoOpFeatureSelection = function (feature) { };
var CaseEvidenceTable2 = /** @class */ (function (_super) {
    __extends(CaseEvidenceTable2, _super);
    function CaseEvidenceTable2(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    CaseEvidenceTable2.prototype.handleClick = function (ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('span');
        var valuable = target.classList.contains('field-value')
            ? target
            : target.closest('.field-value');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('.case-evidence-item.case-evidence-linked');
        if (!valuable || !linkable)
            return;
        var item = linkable.attributes.getNamedItem('data-index');
        if (!item)
            return;
        var chargeSessionCode = this.props.chargeSessionCode;
        var currentIndex = parseInt(item.value);
        var evidence = chargeSessionCode.evidence[currentIndex];
        if (evidence) {
            var display = !linkable.classList.contains('case-evidence-active');
            var selectionState = {
                active: display,
                hover: false,
                visible: true
            };
            this.props.onFeatureSelection({
                chargeSessionCode: chargeSessionCode,
                evidence: [evidence],
                selectionState: selectionState
            });
        }
    };
    CaseEvidenceTable2.prototype.render = function () {
        var _a = this.props, chargeSessionCode = _a.chargeSessionCode, panelActivations = _a.panelActivations, techTransaction = _a.techTransaction;
        var evidence = chargeSessionCode.evidence;
        var evidenceDisplay = evidence.map(function (evida, idx) {
            var _a, _b, _c, _d;
            var isActive = (_b = (_a = panelActivations[evida.hash]) === null || _a === void 0 ? void 0 : _a.active) !== null && _b !== void 0 ? _b : false;
            var styleClasses = [
                "case-evidence-item",
                {
                    'case-evidence-linked': evida.linkable,
                    'case-evidence-active': isActive,
                    'sentence-highlight': evida.featureType === ui_common_1.commonEnums.EvidenceType.PARTIAL,
                    'categorical-highlight': evida.featureType === ui_common_1.commonEnums.EvidenceType.COMPLETE
                }
            ];
            var valueClasses = [
                "field-value",
                'highlighted-text',
                'sensitive-data'
            ];
            var fieldName = _case_lang_1.FieldNames[evida.fieldName] || evida.fieldName;
            var verb = evidenceVerb[evida.featureType] || evida.featureType;
            var content = ((_d = (_c = evida.meta) === null || _c === void 0 ? void 0 : _c.content) !== null && _d !== void 0 ? _d : 'N/A').trim();
            if (evida.linkable) {
                content = (0, jsx_runtime_1.jsx)("a", __assign({ href: "".concat(evida.identifier) }, { children: content }));
            }
            return ((0, jsx_runtime_1.jsxs)("li", __assign({ className: (0, classnames_1["default"])(styleClasses), "data-index": idx }, { children: ["The ", (0, jsx_runtime_1.jsx)("span", __assign({ className: "field-name" }, { children: fieldName })), " ", verb, ' ', (0, jsx_runtime_1.jsx)("span", __assign({ className: (0, classnames_1["default"])(valueClasses) }, { children: content }))] }), idx));
        });
        var codeType = chargeSessionCode.codeType.toLowerCase();
        var classes = [
            'case-evidence-table',
            'case-evidence-table2',
            'col-artifacts',
            "case-evidence-".concat(codeType)
        ];
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(classes) }, { children: [(techTransaction.hasProCode || techTransaction.hasTechCode) && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h5", { children: "BILLING DETAILS" }), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "case-evidence-list" }, { children: (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsxs)("span", __assign({ className: "qa-empty-message empty-item-message tech-item" }, { children: [(techTransaction.isProCodeActive ||
                                            techTransaction.isTechCodeActive) && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "case-evidence-item" }, { children: ["This ", codeType === 'procedure' ? 'charge' : 'modifier', ' ', "will be submitted", ' ', codeType === 'procedure' ? 'as' : 'with', ' ', (0, jsx_runtime_1.jsx)("b", { children: techTransaction.isProCodeActive &&
                                                        techTransaction.proCode }), techTransaction.isProCodeActive &&
                                                    techTransaction.isTechCodeActive &&
                                                    ' and ', (0, jsx_runtime_1.jsx)("b", { children: techTransaction.isTechCodeActive &&
                                                        techTransaction.techCode })] }))), !techTransaction.isProCodeActive &&
                                            !techTransaction.isTechCodeActive && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "case-evidence-item" }, { children: "The charge will not be submitted without a billing designation." })))] })) }) }))] })), evidence.length > 0 ? ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("h5", { children: ["WHY WE SELECTED ", chargeSessionCode.code] }), (0, jsx_runtime_1.jsx)("ol", __assign({ onClick: this.handleClick, className: "case-evidence-list" }, { children: evidenceDisplay }))] })) : ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h5", { children: "NO EVIDENCE AT THE MOMENT" }), (0, jsx_runtime_1.jsx)("ul", __assign({ className: "case-evidence-list" }, { children: (0, jsx_runtime_1.jsx)("li", { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "qa-empty-message empty-item-message no-evidence" }, { children: "There is no displayable evidence at this time." })) }) }))] }))] })));
    };
    CaseEvidenceTable2.displayName = 'CaseEvidenceTable2';
    CaseEvidenceTable2.defaultProps = {
        onFeatureSelection: NoOpFeatureSelection,
        panelActivations: {},
        techTransaction: {}
    };
    return CaseEvidenceTable2;
}(react_1["default"].Component));
exports.CaseEvidenceTable2 = CaseEvidenceTable2;
//# sourceMappingURL=case-evidence-table2.js.map